import * as React from "react";
import styled from "styled-components";

import { Icon } from "src/library/components/Icon";
import { Text } from "src/library/components/Text";
import { ITerminology } from "src/library/utils/string-manipulations/tokenize-string";
import ListNote from "src/core/lists/components/ListNote";
import { Icons } from "src/library/components/Icon/types";

import { IList } from "../api/lists.api";

interface ListNotesProps {
  list: IList;
  terminology: ITerminology;
}

const ListNotes: React.ReactFCWithChildren<ListNotesProps> = props => {
  const { list, terminology } = props;
  const { listNotes: notes } = list;
  const [ showNotes, setShowNotes ] = React.useState(false);

  const handleToggleShowNotes = () => {
    setShowNotes(!showNotes);
  };

  if (!props.list) {
    return null;
  }

  return (
    <Wrapper>
      {notes && notes.length > 0 && (
        <>
          <NoteHeaderGroup onClick={() => handleToggleShowNotes()}>
            <Text fontSize="h2">
              {`This ${terminology.list.singular.text} has `}
            </Text>

            <Text
              fontSize="h2"
              weight="bold"
            >
              {`${notes.length} note${notes.length > 1 ? "s" : ""}`}
            </Text>

            <Icon
              className="icon"
              icon={showNotes ? Icons.CHEVRONUP : Icons.CHEVRONDOWN}
              $fillColor="lightGrey"
              size={24}
            />
          </NoteHeaderGroup>

          {showNotes && (
            <Group>
              {notes.map((note, i) => {
                return (
                  <ListNote
                    key={i}
                    note={note}
                  />
                );
              })}
            </Group>
          )}
        </>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.margins.md};
`;

const Group = styled.div``;

const NoteHeaderGroup = styled.div`
  background-color: white;
  border-radius: ${({ theme }) => theme.borderRadius};
  padding: ${({ theme }) => theme.spacing.padding.md};
  margin-top: ${({ theme }) => theme.spacing.padding.md};
  .icon {
    position: relative;
    top: 3px;
    float: right;
  }
`;

export default ListNotes;
